<header>
  <div class="container pt-3 d-flex justify-content-center">
      <div class="row justify-content-md-center align-items-center">
        <div *ngIf="logoEleicao != null" class="col-md-auto logohe" style="min-width: 90px;  max-height:138px;">
          <img [src]="logoEleicao"
            class="img-fluid" style="max-height:138px; width:390" alt="Responsive image">
        </div>

        <div *ngIf="logoEleicao == null" class="col-md-auto logohe" style="min-width: 90px; max-width: 240px; height:66px;">
          <img [src]="'../assets/img/logo/logo-sinqia.png'"
            class="img-fluid" style="max-height:66px;" alt="Responsive image">
      </div>
    </div>
  </div>
</header>
